import { ObservationService } from 'client/services';
import CMSService from 'client/services/CMS/CMS.service';

const loader = async ({ params }) => {
    const { observationId } = params;

    const [
        disclaimerContent,
        observationTypes,
        editingObservation
    ] = await Promise.all([
        CMSService.getObservationsDisclaimer(),
        ObservationService.getObservationTypes(),
        observationId ? ObservationService.getObservation(observationId) : null
    ]);

    return { editingObservation, disclaimerContent, observationTypes };
};

export default loader;
